import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { LogoIcon } from '../appearence/icons/logo_icon';
import { useTranslation } from 'react-i18next';
import CommitInfo from './../shared/CommitInfo';
import { keyDownService } from '../services/keyDownService';
import PasswordField from './../shared/PasswordField';
import { Button } from '@chapche/ui';
import {loginManager, NEW_PASSWORD_KEY, REPEAT_PASSWORD_KEY} from "../shared/loginManager";


const ResetPasswordPage = () => {
    const [isDisabled, setIsDisabled] = useState(true);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code');
    const { i18n } = useTranslation();

    const successChangePasswordCallback = () => {
        navigate("/login");
    };

    const handleResetPassword = () => {
        loginManager.sendUpdatePasswordRequest(code, successChangePasswordCallback);
    };

    const changeIsDisabled = () => {
        setIsDisabled(!loginManager.canSendRequest());
    };

    useEffect(() => {
        loginManager.registerLoginUpdateObserver(changeIsDisabled);
        return () => loginManager.unRegisterLoginUpdateObserver(changeIsDisabled);
    }, []);

    return (
        <>
            <header className="login__header">
                <LogoIcon />
                <CommitInfo />
            </header>
            <main className="login" onKeyDown={(e) => keyDownService.saveNewItem(e, handleResetPassword)}>
                <h1 className="login__title block__title-h3">{i18n.t('public.app.page.login.passwordCreating')}</h1>
                <form className="login__form">
                    <PasswordField label={i18n.t('public.app.page.login.password')} passwordType={NEW_PASSWORD_KEY}/>
                    <PasswordField label={i18n.t('public.app.page.login.repeatPassword')} passwordType={REPEAT_PASSWORD_KEY}/>
                    <Button type="button" className="login__button" disabled={isDisabled} onClick={handleResetPassword}>
                        {i18n.t('app.page.product.modal.create')}
                    </Button>
                </form>
            </main>
        </>
    );
};

export default ResetPasswordPage;
